import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  createTheme,
  Fade,
  Paper,
  Popper,
  TextField,
  ThemeProvider,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { makeLogin } from "../../api/auth";
import { jwtDecode } from "jwt-decode";
import {
  setDrawer,
  setIsAdmin,
  setIsClubChecker,
  setIsClubMaker,
  setToken,
  setUserDetails,
} from "../../redux/reducers/common";
import { getUser } from "../../api/user";
import { getClub } from "../../api/club";
import { setCurrentClub } from "../../redux/reducers/clubDetails";
import { useLocation, useNavigate } from "react-router";

const theme = createTheme({
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: 50,
        },
      },
    },
  },
});

const AuthModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const token: any = useSelector((state: any) => state.common.token);

  useEffect(() => {
    checkTokenExpiry((a) => setIsOpen(a));
  }, [location, dispatch]);

  const manageLoginClick = () => {
    const doAction = async () => {
      try {
        const data = {
          userName: userName,
          password: password,
        };
        const response = await makeLogin(data);
        return response;
      } catch (error) {}
    };
    doAction().then((res: any) => {
      if (!res || typeof res !== 'string') return;
      const decoded: any = jwtDecode(res);
      const isAdminToken = decoded.roles.includes("JLeagueAdmin");
      const isClubMakerToken = decoded.roles.includes("ClubMaker");
      const isClubCheckerToken = decoded.roles.includes("ClubChecker");
      dispatch(setIsAdmin(isAdminToken));
      dispatch(setIsClubMaker(isClubMakerToken));
      dispatch(setIsClubChecker(isClubCheckerToken));
      dispatch(setToken(decoded));
      localStorage.setItem("token", res);
      localStorage.setItem(
        "_jauth_",
        JSON.stringify({
          token: res,
          roles: decoded.roles,
          exp: decoded.exp,
          clubId: decoded.clubId,
          username: decoded.sub,
        })
      );
      if (isAdminToken) {
        const moduleName: any = "Home";
        dispatch(setDrawer(moduleName));
        navigate("/home");
        getUser().then((res: any) => {
          dispatch(setUserDetails(res));
          localStorage.setItem("user", JSON.stringify(res));
          localStorage.setItem("lang", res.languageCode);
        });
      } else if (isClubMakerToken || isClubCheckerToken) {
        fetchClubDetails(decoded.clubId);
        navigate("/evaluation");
        const moduleName: any = "Evaluation";
        dispatch(setDrawer(moduleName));
        getUser().then((res: any) => {
          dispatch(setUserDetails(res));
          localStorage.setItem("user", JSON.stringify(res));
          localStorage.setItem("lang", res.languageCode);
        });
      }
      setUserName("");
      setPassword("");
      setIsLoading(false);
    });
  };
  const fetchClubDetails = async (clubId: any) => {
    const response = await getClub("GET CLUB DETAILS", { id: clubId });
    dispatch(setCurrentClub(response));
  };
  const manageLogout = () => {
    window.localStorage.removeItem("__jauth__");
    window.localStorage.removeItem("_jauth_");
    window.localStorage.removeItem("lang");
    navigate("/");
  };

  const checkTokenExpiry = (cb: (a: boolean) => void) => {
    const exp = token.exp;
    const now = Math.floor(Date.now() / 1000);

    if (exp - now < 0) {
      manageLogout();
    }

    // 12h left
    if (exp - now < 43200) {
      cb(true);
    } else {
      cb(false);
    }
  };

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <Popper className="popperStyle" open={isOpen} transition>
          {({ TransitionProps }) => (
            // <ClickAwayListener onClickAway={() => {handleClose()}}>
            <Fade {...TransitionProps} timeout={350}>
              <Paper
                sx={{
                  p: 2,
                  width: "300px",
                  maxHeightheight: "40vh",
                  overflowY: "auto",
                  margin: "auto",
                  mt: "10%",
                }}
                // onClick={() => handleClickInsidePopper}
              >
                <Box
                  sx={{ display: "grid", gap: 2, gridTemplateColumns: "auto" }}
                >
                  <Typography className={"fs20 fw800"}>
                    {t("PLEASE_REAUTHENTIFICATE")}
                  </Typography>
                  <TextField
                    className="input"
                    name="userName"
                    placeholder={t("EMAIL_OR_USERNAME")}
                    value={userName}
                    onChange={(e: any) => {
                      setUserName(e.target.value);
                    }}
                  />
                  <TextField
                    className="input"
                    type="password"
                    name="password"
                    placeholder={t("PASSWORD")}
                    value={password}
                    onChange={(e: any) => {
                      setPassword(e.target.value);
                    }}
                  />
                  <LoadingButton
                    id="button"
                    type="button"
                    onClick={() => {
                      manageLoginClick();
                    }}
                    loading={isLoading}
                    variant="contained"
                    disableElevation
                  >
                    {t("LOG_IN")}
                  </LoadingButton>
                  <Button
                    id="button"
                    type="button"
                    onClick={() => {
                      manageLogout();
                    }}
                    variant="contained"
                    disableElevation
                  >
                    {t("CANCEL")}
                  </Button>
                </Box>
              </Paper>
            </Fade>
            // </ClickAwayListener>
          )}
        </Popper>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default AuthModal;
